import { type Transition } from 'framer-motion';

// Good spring curve visualizer here:
// https://emilkowal.ski/ui/great-animations#great-animations-feel-natural
export const tightSpring: Transition = {
  type: 'spring',
  stiffness: 571,
  damping: 32,
  mass: 1
};

export const mediumSpring: Transition = {
  type: 'spring',
  stiffness: 263,
  damping: 25,
  mass: 1
};
